<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <h2>Noticias</h2>
                </div>

                <div class="col-lg-6 col-md-6">
                    <ul>
                        <li><a routerLink="/">Inicio</a></li>
                        <li><a routerLink="/news">Noticias</a></li>
                        <li>{{news.title}}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="blog-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="blog-details-desc">
                    <div class="article-image">
                        <img src="{{news.imageUrl}}" alt="image">
                    </div>
                    <div class="article-content">
                        <div class="entry-meta">
                            <ul style="margin-top: -20px; margin-bottom: 5px;">

                                <li><span>Fecha de publicación: </span><a>{{ news.postedOn | utcToLocal | date: 'short' }}</a></li>
                                <li><span>Autor:</span> <a>{{news.authorName}}</a></li>
                            </ul>
                        </div>
                        <h1>{{news.title}}</h1>
                        <div [innerHTML]="news.content"></div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <aside class="widget-area" id="secondary">
                    <div class="widget widget_search mt-0">
                        <h3 class="widget-title">Buscar</h3>

                        <div class="post-wrap">
                            <form class="search-form">
                                <label>
                                    <span class="screen-reader-text">Search for:</span>
                                    <input [(ngModel)]="searchInput" name="searchInput"  type="search" class="search-field" placeholder="Titulo o Contenido...">
                                </label>
                                <button (click)="searchByTitleOrContent()"><i class='bx bx-search'></i></button>
                            </form>
                        </div>
                    </div>

                    <section class="widget widget-hosta-posts-thumb">
                        <h3 class="widget-title">Populares</h3>

                        <div class="post-wrap-without-overflow">
                         
                            
                            <article (click)="goToNews(item)" *ngFor="let item of topNews" class="item pointer">
                                <a class="thumb">
                                    
                                    <div class="article-image">
                                        <img src="{{item.image}}" alt="image">
                                    </div>
                                </a>
                                <div class="info">
                                    <time>{{item.postedOn | date: 'dd MMMM y' }}</time>
                                    <h4 class="title usmall">
                                        <a >
                                            {{item.title}}
                                        </a>
                                    </h4>
                                </div>

                                <div class="clear"></div>
                            </article>
                  
                            
                          
                        </div>
                    </section>

                    <section class="widget widget_categories">
                        <h3 class="widget-title">Archivo</h3>

                        <div class="post-wrap">
                            <ul>
                                <li [ngClass]="{ 'isActive': item.isActive }" class="pointer" *ngFor="let item of archives" (click)="searchByArchive(item)">
                                    <a >{{item.dateParsed}} <span>({{item.news}})</span></a>
                                  </li>
                            </ul>
                        </div>
                    </section>
                    
                    <section class="widget widget_categories">
                        <h3 class="widget-title">Categorías</h3>

                        <div class="post-wrap">
                            <ul>
                                <li [ngClass]="{ 'isActive': item.isActive }" class="pointer" *ngFor="let item of categories" (click)="searchByCategory(item)">
                                    <a>{{item.category | uppercase }} <span>({{item.news}})</span></a>
                                  </li>
                            </ul>
                        </div>
                    </section>
                </aside>
            </div>

          
        </div>
    </div>
</section>